import React from 'react';

// Hand-built line florals. Decorative only, so every SVG is aria-hidden.

/** Eight-petal bloom. */
export const Bloom: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round">
    {Array.from({ length: 8 }).map((_, i) => (
      <ellipse key={i} cx="50" cy="26" rx="8" ry="20" transform={`rotate(${i * 45} 50 50)`} />
    ))}
    <circle cx="50" cy="50" r="5" fill="currentColor" stroke="none" opacity="0.5" />
  </svg>
);

/** Lavender sprig: a curved stem with paired buds. */
export const Sprig: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 80 220" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round">
    <path d="M40 215 C38 160 44 100 40 20" />
    {Array.from({ length: 7 }).map((_, i) => {
      const y = 30 + i * 22;
      return (
        <g key={i}>
          <ellipse cx="30" cy={y} rx="5" ry="9" transform={`rotate(-30 30 ${y})`} />
          <ellipse cx="50" cy={y + 8} rx="5" ry="9" transform={`rotate(30 50 ${y + 8})`} />
        </g>
      );
    })}
    <ellipse cx="40" cy="12" rx="4" ry="9" />
  </svg>
);
